import { useEffect, useState } from "react";
import ImgError from "../../assets/images/error-404.svg";
import { THEME_COLOR } from "./../../config/config";
import { list404PageContent } from "./../../config/api_calls"; // Already correct
import HelperClass from "./../../config/helperClass";

const auth = new HelperClass();

export default function Error404() {
  const [customHtml, setCustomHtml] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch404Page = async () => {
      try {
        const response = await list404PageContent(
          auth.getAccount(),
          auth.getToken()
        );

        if (
          response.data.status === 403 ||
          response.data.errors === "authentication missing" ||
          response.data.errors === "jwt expired"
        ) {
          auth.logout();
        } else if (
          response.data.status === 200 &&
          response.data.message === "success"
        ) {
          const page404 = response.data.data[0];
          const htmlContent = page404?.[6];

          if (htmlContent) {
            setCustomHtml(htmlContent);
          }
        } else {
          window.location.replace("/error");
        }
      } catch (error) {
        // console.error("Failed to load 404 page data", error);
        window.location.replace("/error");
      } finally {
        setLoading(false); // ALWAYS stop loading
      }
    };

    fetch404Page();
  }, []);

  return (
    <div className="nk-body bg-white npc-general pg-error">
      <div className="nk-app-root">
        <div className="nk-main">
          <div className="nk-wrap justify-center">
            <div className="nk-content">
              <div className="nk-block nk-block-middle wide-md mx-auto">
                <div className="nk-block-content nk-error-ld text-center">
                  {loading ? null : customHtml ? (
                    <div dangerouslySetInnerHTML={{ __html: customHtml }} />
                  ) : (
                    <>
                      <img className="nk-error-gfx" src={ImgError} alt="" />
                      <div className="wide-xs mx-auto">
                        <h3 className="nk-error-title">
                          Oops! Why you’re here?
                        </h3>
                        <p className="nk-error-text">
                          We are very sorry for the inconvenience. It looks like
                          you’re trying to access a page that either has been
                          deleted or never existed.
                        </p>
                        <a
                          href="/"
                          className="btn btn-lg mt-2"
                          style={{
                            backgroundColor: THEME_COLOR,
                            color: "white",
                          }}
                        >
                          Back To Home
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
